const directionPageArr = [
  { 
      page: "global",
      menu: 'userMenu',
      header: 'userHeader',
      footer: 'globalFooter'
  },
  {
      page: "HomePage",
      menu: false
  },
  {
      page: "UsersSignIn",
      menu: false
  },
  {
      page: "UsersLogin",
      menu: false
  },
  {
      page: "UsersForgotPassword",
      menu: false
  },
  {
      page: "TosPage",
      menu: "questMenu"
  },
  {
      page: "PrivacyPage",
      menu: "questMenu"
  },
  {
      page: "CookiePolicyPage",
      menu: "questMenu"
  },
  {
      page: "ContactPage",
      menu: "questMenu"
  },
  {
      page: "ErrorPage",
      menu: false
  },
  {
      page: "Error404",
      menu: false
  },
  {
      page: "AdminHome",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSettings",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSiteSettings",
      menu: "adminMenu",
      header: "adminHeader", 
      footer: "adminFooter"
  },
  {
      page: "AdminUsers",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminAnalytics",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminLogs",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchema",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchemaCreate",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchemaUpdate",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminSchemaDetail",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "AdminContacts",
      menu: "adminMenu",
      header: "adminHeader",
      footer: "adminFooter"
  },
  {
      page: "TasksHome",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksCreate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksUpdate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksDetail",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksList",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "TasksSearch",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "KanbanBoard",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "CalendarView",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidHome",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidCreate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidUpdate",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidDetail",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidList",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "MermaidSearch",
      menu: "userMenu",
      header: "userHeader",
      footer: "globalFooter"
  },
  {
      page: "QuestionsList",
      menu: false
  },
  {
      page: "ExamsSolve",
      menu: false,
      header: false,
      footer: false
  },
  {
      page: "ExamsAnswers",
      menu: false,
      header: false,
      footer: false
  },
  {
      page: "LoginFirebaseToken",
      menu: false,
      header: false,
      footer: false
  }
];

export default directionPageArr;
